(() => {
  function init(root) {
    if (!root || root.dataset.catalogReady) return;
    root.dataset.catalogReady = 'true';
    const rail = root.querySelector('[data-product-rail]');
    if (!rail) return;
    const cards = [...rail.querySelectorAll('[data-product-card]')];
    const filters = [...root.querySelectorAll('[data-category-filter]')];
    const count = root.querySelector('[data-catalog-count]');
    const prev = root.querySelector('[data-catalog-prev]');
    const next = root.querySelector('[data-catalog-next]');
    const controls = root.querySelector('[data-carousel-controls]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    rail.classList.add('is-carousel');
    if (controls) controls.hidden = false;
    const updateControls = () => {
      const hasOverflow = rail.scrollWidth > rail.clientWidth + 2;
      if (prev) prev.disabled = !hasOverflow || rail.scrollLeft <= 8;
      if (next) next.disabled = !hasOverflow || rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 8;
    };
    const filter = category => {
      let visible = 0;
      cards.forEach(card => {
        card.hidden = category !== 'all' && card.dataset.category !== category;
        if (!card.hidden) visible++;
      });
      filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.categoryFilter === category)));
      count.textContent = `${visible} ${visible === 1 ? 'product' : 'products'}`;
      root.querySelector('[data-catalog-empty]').hidden = visible !== 0;
      rail.scrollTo({left: 0, behavior: 'instant'});
      requestAnimationFrame(() => {
        rail.scrollTo({left: 0, behavior: 'instant'});
        updateControls();
      });
    };
    filters.forEach(button => button.addEventListener('click', () => filter(button.dataset.categoryFilter)));
    document.querySelectorAll('[data-category-link]').forEach(link => link.addEventListener('click', () => {
      filter(link.dataset.categoryLink);
      const menu = link.closest('details');
      if (menu) menu.open = false;
    }));
    const move = direction => rail.scrollBy({left: direction * Math.max(240, rail.clientWidth * .8), behavior: reducedMotion.matches ? 'instant' : 'smooth'});
    if (prev) prev.addEventListener('click', () => move(-1));
    if (next) next.addEventListener('click', () => move(1));
    rail.addEventListener('scroll', updateControls, {passive: true});
    if ('ResizeObserver' in window) new ResizeObserver(updateControls).observe(rail);
    else window.addEventListener('resize', updateControls);
    const requestedCategory = new URLSearchParams(window.location.search).get('category');
    const knownCategories = ['all', 'supplements', 'skincare', 'recovery', 'light', 'guides'];
    filter(knownCategories.includes(requestedCategory) ? requestedCategory : 'all');
  }
  document.querySelectorAll('[data-holist-catalog]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-holist-catalog]').forEach(init));
})();
